// import { useAuthStore } from './authStore';
import { useTalentPoolsStore } from './talentPoolsStore';
import { useProjectsStore } from './projectsStore';

export function resetAllStores() {
//   const authStore = useAuthStore();
  const talentPoolsStore = useTalentPoolsStore();
  const projectsStore = useProjectsStore();

//   authStore.resetStore();
  talentPoolsStore.resetStore();
  projectsStore.resetStore();

}